import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  downloadButton: {
    id: 'portal.views.certificate.download.button.text',
    defaultMessage: 'Download',
    description: 'Download button text',
  },
  certificateOfAchievement: {
    id: 'portal.views.certificate.certificateOfAchievement.heading',
    defaultMessage: 'Certificate of Achievement',
    description: 'Certificate of Achievement heading',
  },
  presentedTo: {
    id: 'portal.views.certificate.presentedTo.text',
    defaultMessage: 'This certificate is proudly presented to',
    description: 'Presented to text',
  },
  completionOfModule: {
    id: 'portal.views.certificate.completionOfModule.text',
    defaultMessage: 'For successful completion of the module',
    description: 'Completion of module text',
  },
  courseJourney: {
    id: 'portal.views.certificate.courseJourney.text',
    defaultMessage: 'Course Journey',
    description: 'Course Journey text',
  },
  leadingWithCharacterDesc: {
    id: 'portal.views.certificate.leadingWithCharacterDesc.text',
    defaultMessage: 'Leading with Character is a 30-day leadership journey designed to help '
      + 'leaders build a clear leadership vision, cultivate their character, and use their influence for good',
    description: 'Leading with Character description',
  },
  website: {
    id: 'portal.views.certificate.website.text',
    defaultMessage: 'www.leadingwithcharacter.com',
    description: 'Website text',
  },
  certificateNotFound: {
    id: 'portal.views.certificate.not.found.text',
    defaultMessage: 'Certificate not found',
    description: 'Certificate error message',
  },
  certificateLoadError: {
    id: 'portal.views.certificate.load.error.text',
    defaultMessage: 'Certificate loading problem',
    description: 'Certificate error message',
  },
  uuidIsEmpty: {
    id: 'portal.views.certificate.uuid.empty.text',
    defaultMessage: 'UUID is empty',
    description: 'Certificate error message',
  },
});

export default messages;
